import { ProjectHolidayForm } from "@/components/forms/contract/nieuw-contract/ProjectHolidayForm"
import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { Button, FormStyle, PageHeader } from "toptaal-shared"

export const Route = createFileRoute(
  "/beheer/contracten/wijzigen/$contractId/vakanties",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()

  const { contractId } = useParams({
    from: "/beheer/contracten/wijzigen/$contractId/vakanties",
  })

  return (
    <ScreenWrapper showManagementMenu>
      <FormStyle className="mx-auto my-8">
        <PageHeader className="mb-8 text-center">Vakanties wijzigen</PageHeader>

        <ProjectHolidayForm
          type="edit"
          projectId={Number(contractId)}
          submitButton={(isValid, isPending) => (
            <div className="flex justify-end gap-4 mt-4">
              <Button
                type="button"
                variant="ghost"
                onClick={() => router.history.back()}
              >
                Annuleren
              </Button>

              <Button type="submit" disabled={!isValid || isPending}>
                Opslaan
              </Button>
            </div>
          )}
        />
      </FormStyle>
    </ScreenWrapper>
  )
}
